import React, {useState} from 'react'
import { Link } from 'react-router-dom';

import Container from '@material-ui/core/Container';

import CurrencySelector from '../../NewCurrencySelector';
import SpotlioIcon from '../../Icon';
import MobileTabs from '../HeaderTabs/mobile';
import Typography from "../../Typography";
import LanguageSelector from "../../LanguageSelector"
import Avatar from '../../Avatar';

import IntlMessage from '../../../LocaleEngine';
import { getSystemSettings } from '../../../utils/SettingsRetriever';
import { getCookie } from '../../../utils/CookiesRetriever';

import TATO from './TATO';

import './index.scss';
import Currency from '../../Currency';

let alreadyInstalled = false;

export default (props) => {
    const [ menu, toggleMenu2 ] = useState(false);
    const configuration = getSystemSettings();

    const toggleMenu = function (value) {
        if (window && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
            window.ReactNativeWebView.postMessage('Menu ' + (value ? 'abierto' : 'cerrado'));
        }
        toggleMenu2(value);
    };

    if (alreadyInstalled === false) {
        window.addEventListener("message", function (event) {
            // toggleMenu2(....)
        }, false);
        
        document.addEventListener("message", function (event) {
            // toggleMenu2(....)
        }, false);

        alreadyInstalled = true;
    }

    let menuIcon = 'sp3-menu';
    if(! !configuration.assets.mobile.menu_icon) menuIcon = configuration.assets.mobile.menu_icon;

    let shoppingCartIcon = 'sp2-shopping-cart';
    if(! !configuration.assets.mobile.cart_icon) shoppingCartIcon = configuration.assets.mobile.cart_icon;

    // let showLanguage = false;  USING MOCK ATM
    // if(! !configuration.head.multilanguage) showLanguage = configuration.head.multilanguage;

    let showCurrency = false;
    if(! !configuration.head.multicurrency) showCurrency = configuration.head.multicurrency;

    let showProfile = false;
    if(! !configuration.head.profile) showProfile = configuration.head.profile;

    const b2bCookie = JSON.parse(getCookie('b2b'));

    const headMode = configuration.head.mode || "default";

    const renderTopbarLogo = () => {
        const logo = <img className={(configuration.head.logo ? "bigLogo " : " ") + ""} alt={configuration.head.title} src={configuration.assets.logo || "https://shopspotlio.spotlio.com/bundles/spotliowebappfront/spotlio/images/logo-copper.png"} />
        if (configuration.head.site_url === '#' || !configuration.head.site_url) {
            return (
                <div className="logoWrapper">
                    { logo }
                </div>
            );
        } else {
            return (
                <a className="logoWrapper" rel="noopener noreferrer" target="_blank" href={configuration.head.site_url} title={configuration.head.title}>
                    { logo }
                </a>
            )
        }
    }

    const renderCartBullet = () => {
        if (b2bCookie) return null;
        else {
            return (
                <div onClick={props.onTrigger} className="cartBadge">
                    <div className="cartIcon">
                        <SpotlioIcon icon="sp2-shopping-cart" />
                        <div className="cartCounter">
                            <Typography className="h300bold">
                                2
                            </Typography>
                        </div>
                    </div>
                    <Currency float={true} value={829} />
                </div>
            )
        }
    }

    const renderOptions = () => {
        if (b2bCookie) {
            return (
                <TATO cartLength={props.cartLength} onCartTrigger={props.onTrigger} b2bCookie={b2bCookie} />
            )
        } else {
            return (
                <React.Fragment>
                    <div className="links">
                        <ul>
                            {
                                showCurrency ? 
                                    <CurrencySelector mode="b2c" />
                                : ''
                            }
                            {
                                // showLanguage ?
                                    <LanguageSelector />
                                // : ''
                            }
                            {
                                showProfile ? 
                                    <Avatar>
                                        <Link to={getSystemSettings().urlPrefix + '/account'}><IntlMessage id="header.info.my_account" /></Link>
                                    </Avatar>
                                : ''
                            }
                        </ul>
                    </div>
                </React.Fragment>
            )
        }
    }

    const renderBoxedHeader = () => {
        return (
            <header className="boxedTopbarWrapper">
                <Container className="container" maxWidth="lg">
                    <div className="content">
                        <div className="logo">
                            { renderTopbarLogo() }
                        </div>
                        <ul className="menuItems">
                            {
                                configuration.head.links.map(idx => {
                                    return (
                                        <li className="menuItem">
                                            <a href={idx.href}>
                                                {idx.name}
                                            </a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        { renderCartBullet() }
                    </div>
                </Container>
                <div className="options">
                    { renderOptions() }
                </div>
            </header>
        );
    }

    return (
        <React.Fragment>
            { headMode === "boxed" && renderBoxedHeader() }
            <header className={"newTopbarWrapper " + headMode}>
                <MobileTabs toggleMenu={toggleMenu.bind(this)} menu={menu}/>
                <Container className="container" maxWidth="lg">
                    <div onClick={()=>toggleMenu(true)} className="menu">
                        <SpotlioIcon icon={menuIcon} />
                    </div>
                    <div className="logo">
                        { renderTopbarLogo() }
                    </div>

                    <div className="cart">
                        <span className="fa-stack has-badge" data-count={0}>
                            <Link to={getSystemSettings().urlPrefix + '/cart'} className="shoppingcart">
                                <SpotlioIcon icon={shoppingCartIcon} className="shoppingcart" />
                            </Link>
                        </span>
                    </div>
                    <div className="options">
                        { renderOptions() }
                    </div>
                    { renderCartBullet() }
                </Container>
            </header>
        </React.Fragment>
    )
};
